import { render, staticRenderFns } from "./offenders.vue?vue&type=template&id=f56be8fe&scoped=true"
import script from "./offenders.vue?vue&type=script&lang=js"
export * from "./offenders.vue?vue&type=script&lang=js"
import style0 from "./offenders.vue?vue&type=style&index=0&id=f56be8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56be8fe",
  null
  
)

export default component.exports